import { render, staticRenderFns } from "./order-view-tabs-communication.vue?vue&type=template&id=2cf79225&scoped=true&"
import script from "./order-view-tabs-communication.ts?vue&type=script&lang=ts&"
export * from "./order-view-tabs-communication.ts?vue&type=script&lang=ts&"
import style0 from "./order-view-tabs-communication.vue?vue&type=style&index=0&id=2cf79225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf79225",
  null
  
)

export default component.exports